/** Mock options for pick list – use in stories and tests. Use with loadOptions that returns Promise of filtered list. */
export const MOCK_PICK_LIST_OPTIONS = [
  { label: 'LM Brokerage and Logistics', value: 'lm-brokerage' },
  { label: 'HLCU (Hapag Lloyd)', value: 'hlcu' },
  { label: 'Expeditors', value: 'expeditors' },
  { label: 'Seaboard Marine', value: 'seaboard-marine' },
  { label: 'Marine Transport Co', value: 'marine-transport' },
  { label: 'Maersk Line', value: 'maersk' },
  { label: 'MSC', value: 'msc' },
  { label: 'COSCO', value: 'cosco' },
  { label: 'CMA CGM', value: 'cma-cgm' },
  { label: 'Evergreen', value: 'evergreen' },
  { label: 'ONE (Ocean Network Express)', value: 'one' },
]

/** Returns options with value === label (display string) so stored filter value matches what the user sees. */
export const createMockLoadOptions =
  (opts: Array<{ label: string; value: string }> = MOCK_PICK_LIST_OPTIONS) =>
  (search: string, _limit?: number, _notIn?: string[], _skip?: number) =>
    Promise.resolve(
      opts
        .filter(opt => opt.label.toLowerCase().includes(search.toLowerCase()))
        .map(opt => ({ label: opt.label, value: opt.label })),
    )

/** For Storybook: returns options with original value (e.g. hyphenated ids) so stories like WithSelections work. */
export const createMockLoadOptionsForStorybook =
  (opts: Array<{ label: string; value: string }> = MOCK_PICK_LIST_OPTIONS) =>
  (search: string, _limit?: number, _notIn?: string[], _skip?: number) =>
    Promise.resolve(
      opts.filter(opt =>
        opt.label.toLowerCase().includes(search.toLowerCase()),
      ),
    )
